import { Box, Divider, Button } from "@mui/material";
import QuickSearch from "./QuickSearch";
import DocumentTypeFilter from "./DocumentTypeFilter";
import FieldSearchForm from "./FieldSearchForm";
import DateSearchForm from "./DateSearchForm";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDocumentData } from "../../../../store/actions/documentAction";
export default function SidePanel() {
  const dispatch = useDispatch();

  const [docTypes, setDocTypes] = useState([]);
  const [dates, setDates] = useState({});
  const [fieldValues, setFieldValues] = useState({});
  const [quickSearch, setQuickSearch] = useState("");

  const ordersLocation = useSelector(
    ({ orderReducer }) => orderReducer.ordersLocation
  );

  const buildDateFilters = () =>
    Object.entries(dates)
      .filter(([_, v]) => v)
      .map(([key, v]) => ({
        dateType: key,
        fromDate: v.fromDate,
        toDate: v.toDate
      }));

  const handleQuickSearchChange = (value) => {
    setQuickSearch(value);
    // if (value) {
    //   setFieldValues({});
    //   setDates({});
    // }
  };

  const handleSubmit = () => {
    const isQuickSearch = Boolean(quickSearch);

    const payload = {
      searchType: isQuickSearch ? 1 : 2,
      page: 1,
      size: 50,
      locationNumber: ordersLocation?.locationNumber,
      
      ...(isQuickSearch
        ? { searchString: quickSearch }
        : {
            ...fieldValues,
            dateFilters: buildDateFilters(),
            docTypeCode: docTypes,
          })
    };

    dispatch(getDocumentData(payload));
  };

  // check if any field value is filled
  const hasFieldValues = Object.values(fieldValues).some(
    (v) => v !== "" && v !== null && v !== undefined
  );

  // check if any valid date range exists
  const hasDates = Object.values(dates).some(
    (d) => d?.fromDate && d?.toDate
  );

  // check quick search
  const hasQuickSearch = Boolean(quickSearch);

  // final submit enable condition
  const isSubmitEnabled = !hasQuickSearch && ( hasFieldValues || hasDates);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* Scrollable content */}
      <Box sx={{ flex: 1, overflowY: "auto", pr: 1 }}>
        <QuickSearch
          value={quickSearch}
          onChange={handleQuickSearchChange}
          handleSubmit={handleSubmit}
        />

        <Divider sx={{ my: 1 }} />

        <DocumentTypeFilter onChange={setDocTypes} disabled={Boolean(quickSearch)}/>

        <Divider sx={{ my: 1 }} />

        <FieldSearchForm
          values={fieldValues}
          onChange={setFieldValues}
          disabled={Boolean(quickSearch)}
        />

        <Divider sx={{ my: 1 }} />

        <DateSearchForm
          value={dates}
          onChange={setDates}
          disabled={Boolean(quickSearch)}
        />
      </Box>

      {/* Sticky footer */}
      <Box
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "#fff",
          borderTop: "1px solid #ddd",
          p: 1
        }}
      >
        <Button
          fullWidth
          variant="contained"
          onClick={handleSubmit}
          disabled={!isSubmitEnabled}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
}
